import { createSelector } from 'reselect';
import { formatDate } from 'core/utils/apis/responseParsers/commonParsers/formatDateParser';

const formatOfferDate = offer => (
  offer.expires && !offer.isOngoing ? {
    ...offer,
    expires: formatDate(offer.expires, 'MMM DD, YYYY'),
  } : offer
);

export const selectCategoryMerchantsTable = state => state.categoryMerchantsTable;
export const selectCategoryMerchantsTableConfig = createSelector(
  selectCategoryMerchantsTable,
  categoryMerchantsTable => categoryMerchantsTable.config,
);

export const selectCategoryMerchantsTableIsLoading = createSelector(
  selectCategoryMerchantsTable,
  categoryMerchantsTable => categoryMerchantsTable.isLoading,
);

export const selectCategoryMerchantsTableIsLoaded = createSelector(
  selectCategoryMerchantsTable,
  categoryMerchantsTable => categoryMerchantsTable.isLoaded,
);

export const selectCategoryMerchantsTableData = createSelector(
  selectCategoryMerchantsTable,
  (categoryMerchantsTable) => {
    const { data } = categoryMerchantsTable;
    if (data && data.length) {
      return data.map(merchant => ({
        ...merchant,
        offers: merchant.offers.length ? merchant.offers.map(offer => formatOfferDate(offer)) : [],
      }));
    }
    return data;
  },
);

export const selectCategoryMerchantsTableMetadata = createSelector(
  selectCategoryMerchantsTable,
  categoryMerchantsTable => categoryMerchantsTable.metadata,
);
